// src/pages/Dashboard.jsx
import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import Chart from 'react-apexcharts';
import dashboardService from '../services/dashboardService';
import Sidebar from '../components/Sidebar';

export default function Dashboard() {
  // 1) Initialisation à « 0 » ou vides
  const [counts,      setCounts]      = useState({ clients: 0, tikane: 0, transactions: 0 });
  const [statusData,  setStatusData]  = useState({ labels: [], series: [] });
  const [monthlyData, setMonthlyData] = useState({ months: [], amounts: [] });

  useEffect(() => {
    // 2) Charger les données (même si c'est zéro)
    dashboardService.counts().then(setCounts).catch(() => {});
    dashboardService.accountStatus().then(setStatusData).catch(() => {});
    dashboardService.monthlyDeposits().then(setMonthlyData).catch(() => {});
  }, []);

  return (
    <>
      <Sidebar />

      <Container className="pt-4">
        {/* 1. Cartes de stats */}
        <Row className="mb-4">
          <Col md>
            <Card className="text-center shadow-sm">
              <Card.Body>
                <h5>Clients</h5>
                <h2>{counts.clients}</h2>
              </Card.Body>
            </Card>
          </Col>
          <Col md>
            <Card className="text-center shadow-sm">
              <Card.Body>
                <h5>Comptes Ti Kanè</h5>
                <h2>{counts.tikane}</h2>
              </Card.Body>
            </Card>
          </Col>
          <Col md>
            <Card className="text-center shadow-sm">
              <Card.Body>
                <h5>Transactions</h5>
                <h2>{counts.transactions}</h2>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* 2. Donut : statut des comptes */}
        <Row className="mb-5">
          <Col md={6}>
            <Card className="shadow-sm">
              <Card.Body>
                <h5>Statut des comptes</h5>
                {statusData.series.length > 0 ? (
                  <Chart
                    options={{
                      labels: statusData.labels,
                      colors: ['#000080', '#CCA43B', '#6c757d']
                    }}
                    series={statusData.series}
                    type="donut"
                    height={300}
                  />
                ) : (
                  <p className="text-center text-muted mt-4">
                    Aucun compte à afficher
                  </p>
                )}
              </Card.Body>
            </Card>
          </Col>

          {/* 3. Barres : dépôts mensuels */}
          <Col md={6}>
            <Card className="shadow-sm">
              <Card.Body>
                <h5>Dépôts mensuels</h5>
                {monthlyData.amounts.length > 0 ? (
                  <Chart
                    options={{
                      chart: { toolbar: { show: false } },
                      xaxis: { categories: monthlyData.months }
                    }}
                    series={[{ name: 'Dépôts', data: monthlyData.amounts }]}
                    type="bar"
                    height={300}
                  />
                ) : (
                  <p className="text-center text-muted mt-4">
                    Aucun dépôt à afficher
                  </p>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}
